import React from 'react';

import { CheckCircleIcon, CrossCircleIcon } from '@vlabs/icons';
import i18n from 'i18next';

import './ProgressCell.sass';

const STATUS_OPTIONS = {
  get failed() {
    return i18n.t('verifiers:verifierTest.table.status.failed');
  },
  get success() {
    return i18n.t('verifiers:verifierTest.table.status.success');
  },
};

// FIXME сделать один общий компонент прогресса. это временный вариант

function ProgressCell(status) {
  if (!status) return null;
  const iconsMap = {
    failed: <CrossCircleIcon className="ProgressCell_canceled" />,
    success: <CheckCircleIcon className="ProgressCell_finished" />,
  };

  return (
    <div className="ProgressCell">
      <div title={STATUS_OPTIONS[status]}>
        {iconsMap[status]}
      </div>
    </div>
  );
}

export default ProgressCell;
